module.exports = __webpack_public_path__ + "img/C3CCD4_5F3B23_948A7B_A9A49A-256px.d58813aa.png";